import { ISetting } from '@/types'
import { getAppHost } from '@/utils/getAppHost'

// Dynamic host detection - no hardcoded URLs needed
const HOST = getAppHost()

export const baseSettings: Partial<ISetting> = {
  app: {
    code: 'afa',
    title: 'AFA Play',
    description: 'Enjoy AFA Live in all your screens. Watch live matches, highlights, and more.',
  },
  fonts: {
    base: 'gilroy',
    display: 'gilroy',
  },
  images: {
    ogImage: 'https://www.fanatiz.com/fanatiz/web/other/og-image-Afaplay.png',
    qrCode: '/assets/images/afa/qr.svg',
    lottie: '/assets/lotties/clients/afa/main/loading.json',
    favicons: {
      icon: '/assets/images/afa/favicons/favicon.ico',
      svg: '/assets/images/afa/favicons/icon.svg',
      apple: '/assets/images/afa/favicons/apple-touch-icon.png',
    },
  },
  gtm: {
    id: 'GTM-M8BLKDWF',
    gateway: {
      enabled: true,
    },
  },
  cmp: {
    id: 'f74ecac54210d',
  },
  api: {
    host: HOST,
    cinematicsTag: 'afaProd',
  },
  youbora: {
    accountCode: 'fanatiz',
    active: false,
  },
  intercom: {
    enabled: false,
  },
  optimizely: {
    sdkKey: 'TGhTYhnEYoEbUxpW9qp5h',
    isActive: false,
  },
  wsc: {
    key: ''
  },
  features: {
    teamBranding: true,
  },
}

export const envOverrides: Record<string, Partial<ISetting>> = {
  development: {},
  staging: {},
  production: {
    youbora: {
      accountCode: 'fanatiz',
      active: true,
    },
  },
}